(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function initializeNavigation() {
      const header = document.querySelector('[data-hg-header]');
      const drawer = document.getElementById('HGNavigation');
      const toggle = document.getElementById('HGNavToggle');
      if (!header || !drawer || !toggle || header.dataset.navigationReady) return;
      header.dataset.navigationReady = 'true';
      const desktop = window.matchMedia('(min-width:961px)');
      const disclosures = Array.from(header.querySelectorAll('[data-nav-disclosure]'));
      function closeDisclosures(except) {
        disclosures.forEach(function (detail) { if (detail !== except) detail.open = false; });
      }
      disclosures.forEach(function (detail) {
        detail.addEventListener('toggle', function () { if (detail.open) closeDisclosures(detail); });
        detail.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') { event.preventDefault(); detail.open = false; detail.querySelector('summary').focus(); }
        });
      });
      document.addEventListener('click', function (event) { if (!header.contains(event.target)) closeDisclosures(); });
      header.addEventListener('focusout', function () {
        setTimeout(function () { if (!header.contains(document.activeElement)) closeDisclosures(); }, 0);
      });
      toggle.addEventListener('click', function () {
        closeDisclosures();
        drawer.showModal();
        toggle.setAttribute('aria-expanded', 'true');
        document.body.classList.add('nav-open');
      });
      drawer.querySelector('[data-hg-nav-close]').addEventListener('click', function () { drawer.close(); });
      drawer.addEventListener('click', function (event) {
        const bounds = drawer.getBoundingClientRect();
        if (event.target === drawer && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) drawer.close();
        if (event.target.closest('a')) drawer.close();
      });
      drawer.addEventListener('close', function () {
        toggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('nav-open');
        if (!desktop.matches) toggle.focus();
      });
      desktop.addEventListener('change', function () {
        closeDisclosures();
        if (drawer.open) drawer.close();
      });
    }
    initializeNavigation();
    document.addEventListener('shopify:section:load', initializeNavigation);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-shop-hero]').forEach(function (hero) {
    const images = Array.from(hero.querySelectorAll('.hero__model-img'));
    const products = Array.from(hero.querySelectorAll('[data-hero-product]'));
    const controls = hero.querySelector('[data-hero-controls]');
    const pause = hero.querySelector('[data-hero-pause]');
    const status = hero.querySelector('[data-hero-status]');
    const desktop = window.matchMedia('(min-width: 821px) and (hover: hover)');
    let index = 0;
    let visible = true;
    let hovered = false;
    let focused = false;
    let userPaused = !desktop.matches;
    let playRequested = false;
    let timer;
    if (images.length < 2 || !controls || products.length !== images.length) return;
    controls.hidden = false;
    function effectsOff() { return document.documentElement.classList.contains('motion-off'); }
    function schedule() {
      window.clearTimeout(timer);
      pause.disabled = effectsOff();
      pause.textContent = userPaused || effectsOff() ? pause.dataset.playLabel : pause.dataset.pauseLabel;
      pause.setAttribute('aria-pressed', String(userPaused || effectsOff()));
      if (!visible || ((hovered || focused) && !playRequested) || userPaused || effectsOff() || document.hidden) return;
      timer = window.setTimeout(function () { show(index + 1, false); }, 7000);
    }
    function show(next, manual) {
      index = (next + images.length) % images.length;
      images.forEach(function (image, i) { image.classList.toggle('is-active', i === index); });
      products.forEach(function (product, i) { product.hidden = i !== index; });
      if (manual) {
        userPaused = true;
        playRequested = false;
        status.textContent = (index + 1) + ' / ' + images.length + ': ' + products[index].innerText.trim();
      }
      schedule();
    }
    hero.querySelector('[data-hero-previous]').addEventListener('click', function () { show(index - 1, true); });
    hero.querySelector('[data-hero-next]').addEventListener('click', function () { show(index + 1, true); });
    pause.addEventListener('click', function () { userPaused = !userPaused; playRequested = !userPaused; schedule(); });
    hero.querySelectorAll('[data-hero-visual], [data-hero-shop]').forEach(function (area) {
      area.addEventListener('mouseenter', function () { hovered = true; playRequested = false; schedule(); });
      area.addEventListener('mouseleave', function () { hovered = false; schedule(); });
    });
    hero.addEventListener('focusin', function () { focused = true; playRequested = false; schedule(); });
    hero.addEventListener('focusout', function (event) { focused = hero.contains(event.relatedTarget); schedule(); });
    document.addEventListener('visibilitychange', schedule);
    window.addEventListener('hg:motionchange', schedule);
    desktop.addEventListener('change', function () { userPaused = true; schedule(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; schedule(); }).observe(hero);
    }
    schedule();
  });
  document.querySelectorAll('[data-hero-atmosphere]').forEach(function (atmosphere) {
    const slides = Array.from(atmosphere.querySelectorAll('.hero__atmosphere-slide'));
    if (!slides.length) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = true;
    let current = -1;
    let bag = [];
    let timer;
    function readyIndexes() {
      return slides.reduce(function (indexes, slide, index) {
        if (slide.complete && slide.naturalWidth > 0) indexes.push(index);
        return indexes;
      }, []);
    }
    function setActive(index) {
      current = index;
      slides.forEach(function (slide, i) {
        slide.classList.remove('hero__atmosphere-slide--first');
        slide.classList.toggle('is-active', i === current);
      });
      atmosphere.classList.add('is-ready');
    }
    function nextBackground() {
      const ready = readyIndexes();
      if (!ready.length) return;
      bag = bag.filter(function (index) { return ready.includes(index); });
      if (!bag.length) {
        bag = ready.slice();
        for (let i = bag.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          const saved = bag[i];
          bag[i] = bag[j];
          bag[j] = saved;
        }
        if (bag.length > 1 && bag[bag.length - 1] === current) {
          const saved = bag[0];
          bag[0] = bag[bag.length - 1];
          bag[bag.length - 1] = saved;
        }
      }
      setActive(bag.pop());
    }
    function syncAtmosphere() {
      window.clearTimeout(timer);
      const paused = !visible || document.hidden || reduced.matches || document.documentElement.classList.contains('motion-off');
      atmosphere.classList.toggle('is-paused', paused);
      if (paused || readyIndexes().length < 2) return;
      timer = window.setTimeout(function () {
        nextBackground();
        syncAtmosphere();
      }, 14000);
    }
    function imageAvailabilityChanged() {
      const ready = readyIndexes();
      if (!ready.includes(current)) {
        if (ready.length) nextBackground();
        else setActive(-1);
      }
      syncAtmosphere();
    }
    slides.forEach(function (slide) {
      slide.addEventListener('load', imageAvailabilityChanged);
      slide.addEventListener('error', imageAvailabilityChanged);
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        syncAtmosphere();
      });
      observer.observe(atmosphere.closest('.hero'));
    }
    document.addEventListener('visibilitychange', syncAtmosphere);
    window.addEventListener('hg:motionchange', syncAtmosphere);
    reduced.addEventListener('change', syncAtmosphere);
    imageAvailabilityChanged();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-split"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-promo-product-depth]').forEach(function(panel) {
    let visible = false;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    function syncProductMotion() {
      panel.classList.toggle('is-depth-moving', visible && !document.hidden && !reduced.matches && !document.documentElement.classList.contains('motion-off'));
    }
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function(entries) {
        visible = entries[0].isIntersecting;
        syncProductMotion();
      }, {threshold: 0});
      observer.observe(panel);
    } else {
      visible = true;
    }
    document.addEventListener('visibilitychange', syncProductMotion);
    window.addEventListener('hg:motionchange', syncProductMotion);
    reduced.addEventListener('change', syncProductMotion);
    syncProductMotion();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-band"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hg-trust]').forEach(function (strip) {
    let visible = false;
    function sync() { strip.classList.toggle('is-visible', visible && !document.hidden); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; sync(); }).observe(strip);
    } else {
      visible = true;
      sync();
    }
    document.addEventListener('visibilitychange', sync);
  });

  } catch(e) { console.error(e); }
})();
})();
